<template>
  <el-table
    v-if="!loading && updatePoints && tabData.length > 0"
    height="100%"
    :data="tabData"
    style="width: 100%"
  >
    <el-table-column prop="name" label="名称" width="220"> </el-table-column>
    <el-table-column prop="period" label="本期总能耗">
      <!-- <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.period }}tce 
          </template>
        </template>
        <template v-else>
          {{ scope.row.period }}tce 
        </template>
      </template> -->
    </el-table-column>
    <el-table-column prop="previous" label="上期总能耗">
      <!-- <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.previous }}tce 
          </template>
        </template>
        <template v-else>
          {{ scope.row.previous }}tce 
        </template>
      </template> -->
    </el-table-column>
    <el-table-column prop="ringlv" label="环比率">
      <!-- <template slot-scope="scope">
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.ringlv }}% 
          </template>
        </template>
        <template v-else>
          {{ scope.row.ringlv }}% 
        </template>
      </template> -->
    </el-table-column>
    <el-table-column prop="same" label="同期总能耗">
      <!-- <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.same }}tce 
          </template>
        </template>
        <template v-else>
          {{ scope.row.same }}tce 
        </template>
      </template> -->
    </el-table-column>
    <el-table-column prop="ratiolv" label="同比率">
      <!-- <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.ratiolv }}% 
          </template>
        </template>
        <template v-else>
          {{ scope.row.ratiolv }}% 
        </template>
      </template> -->
    </el-table-column>
  </el-table>
  <div v-else class="row-center tip">
    <img v-if="loading" src="../../../assets/img/loading.png" class="loading" />
    <img v-else src="../../../assets/img/not_found_data.png" alt="" />
  </div>
</template>

<script>
import {
  dateFormat,
} from "../../../util/DateUtil";
import { CompareClassifiedPower } from "../../../api/power";
import exportExcel from "../../../util/excel";
import Axios from "axios";
import { floatFormat } from "../../../util/MathUtil";
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
export default {
  name: "PowerTime",
  props: {
    loops: Array,
    range: String,
    date: Date,
    node: String,
  },
  data() {
    return {
      titles: [],
      loading: false,
      show: false,
      allPoints: [],
      currentCancelTokenSource: null,
      timeDate:""
    };
  },
  watch: {
    diagramStatus(n) {
      if (this.$route.query.uid === "PowerTime") {
        if (n.type === "excel" && this.tabData.length > 0) {
          let data = [["名称", "本期总能耗","上期总能耗","环比率","同期总能耗",'同比率']];
          this.tabData.forEach((d) => {
            data.push([d.name, d.period, d.previous, d.ringlv, d.same, d.ratiolv]);
          });
          // exportExcel(data, "能耗同环比报表", []);
            const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI']
							  letter = letter.filter((e,i)=>i<6)

                let sheetName = ["能耗同环比"+this.dateName+"报表",this.selProjectName,'日期：'+this.timeDate]
						let style =  {
							fill: {
								type: 'gradient',
								gradient: 'angle',
								degree: 0,
								stops: [
								{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
								{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
								{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
								]
							},
							font20:{
								name: 'Arial',
								size: 20,
								bold: true
							},
							font12bold:{
								name: 'Arial',
								size: 12,
								bold: true
							},
							font12:{
								name: 'Arial',
								size: 12,
								// bold: true
							},
							alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
							alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
							border:{
								top: {style:'thin'},
								left: {style:'thin'},
								bottom: {style:'thin'},
								right: {style:'thin'}
							}
						}

						//处理一二层
            
						sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
						sheet.getCell(letter[0]+'1').value = sheetName[0]
						sheet.getCell(letter[0]+'1').font = style.font20
						sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
						
						sheet.mergeCells('A2:B2');
						sheet.mergeCells('C2:'+letter[letter.length-1]+'2');
						sheet.getCell('A2').value = sheetName[1]
						sheet.getCell('C2').value = sheetName[2]
						sheet.getRow(2).font=style.font12bold
						sheet.getRow(2).alignment = style.alignmentLeft
						const rows = sheet.getRows(1, 2);
						rows.map(e=>{e.height = 50 ;return e})

						//表格设置
						let columns = []
						data[0].forEach(item=>{
							columns.push({
								name:item,
							})
						})
						sheet.addTable({
							name: 'MyTable',
							ref: 'A3', // 表格左上角的位置
							headerRow: true,
							totalsRow: false,
							style: {
								theme: 'TableStyleLight1',
								font:{
									name: 'Arial',
									size: 12,
									// bold: true
								},
							},
							columns:columns,
							rows: data.slice(1),
						})

						//表格头部样式
						sheet.getRow(3).height = 59
						sheet.getRow(3).font=style.font12bold
						
						letter.forEach(item=>{
							sheet.getCell(item+'3').fill = style.fill
							sheet.getCell(item+'3').border = style.border
							sheet.getRow(3).alignment = style.alignmentCenter
						})
						data.slice(1).forEach((item,index)=>{
							sheet.getRow(4+index).height = 38
							sheet.getRow(4+index).font=style.font12
							letter.forEach((e,i)=>{
								sheet.getColumn(e).width = 40
								sheet.getCell(e+(4+index)).border = style.border
							})
						
							sheet.getRow(4+index).alignment = style.alignmentCenter
						})
						

						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
						})
        } else {
          this.$message.warning("无图表数据！");
        }
      }
    },
    updatePoints(n) {
      this.currentCancelTokenSource.cancel("请求取消");
      this.reShow();
      this.getPoints(
        this.loops,
        ["ALTERNATE", "SEPARATED"],
        Axios.CancelToken.source()
      );
    },
  },
  computed: {
    dateName(){
				switch (this.range) {
					case 'day':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
					case 'week':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "周"
						break;
					case 'month':
						this.timeDate = dateFormat("YY-mm", this.date)
						return "月"
						break;
					case 'year':
						this.timeDate = dateFormat("YY", this.date)
						return "年"
						break;
					default:
						return "日"
						break;
				}
		},
    selProjectName() {
      return this.$store.getters.selProjectInfo.projectName;
    },
    diagramStatus() {
      return this.$store.state.project.diagramStatus;
    },
    updatePoints() {
      return [this.date, this.range, this.loops,this.node];
    },
    tabData() {
      if (this.allPoints.length > 0) {
        return this.allPoints;
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.getPoints(
      this.loops,
      ["ALTERNATE", "SEPARATED"],
      Axios.CancelToken.source()
    );
  },
  methods: {
    async getPoints(loops, nodes, source) {
      this.currentCancelTokenSource = source;
      this.loading = true;
      this.allPoints = [];
      if (!loops) {
        return;
      }
      let promises = [];
      loops.forEach((item) => {
        let l = item;
        let temp = nodes.map((n) => {
          if (n == "ALTERNATE") {
            let obj = {
              buildingId: item.id,
              compareType: "ALTERNATE",
              date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
              dateRange: this.range.toUpperCase(),
              powerType: this.node.toUpperCase(),
            };
            return CompareClassifiedPower(obj, source);
          } else {
            let obj1 = {
              buildingId: item.id,
              compareType: "SEPARATED",
              date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
              dateRange: this.range.toUpperCase(),
              powerType: this.node.toUpperCase(),
            };
            return CompareClassifiedPower(obj1, source);
          }
        });

        this.savePoints(temp, nodes, l);
        promises = promises.concat(temp);
      });
      await Promise.all(promises);
      this.loading = false;
    },
    async savePoints(promises, nodes, l) {
      let res = await Promise.all(promises);
      let list = {
        name: "",
        id:"",
        period: "", //本期
        previous: "", //上期
        ringlv: "", //环比
        same: "", //同期
        ratiolv: "", //同比
      };
      nodes.forEach((n, j) => {
        let pointsArray = res[j].data.data.data[0];
        list.name = l.name;
        list.id = l.id
        if (n == "ALTERNATE") {
          list.period = pointsArray[1].toFixed(2)+" tce";
          list.previous = pointsArray[0].toFixed(2)+" tce";
          list.ringlv = pointsArray[0]
            ? (
                ((pointsArray[1] - pointsArray[0]) / pointsArray[0]) *
                100
              ).toFixed(2)+" %"
            : "0.00 %";
        } else {
          (list.same = pointsArray[0].toFixed(2)+" %"), //同期
            (list.ratiolv = pointsArray[0]
              ? (
                  ((pointsArray[1] - pointsArray[0]) / pointsArray[0]) *
                  100
                ).toFixed(2)+" %"
              : "0.00 %"); //同比
        }
      });
      this.allPoints.push(list);
      return res;
    },
    reShow() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style scoped lang="less">
.tip {
  width: 100%;
  height: 100%;
  font-size: 16rem;
  color: #8c939d;
}

.loading {
  width: 28rem;
  height: 28rem;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
